import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Créer un fichier join
export const createFileAttachement = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/fileAttachment/create`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const createMemoryOrPV = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/fileAttachment/createMemoryOrPV`,
    payload,
    {
      headers: {
        ...setHeaders(context),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

// Récupérer les fichiers en fonction de l'id de l'entité choisis
export const getFileAttachementByEntityId = async (
  id_entity,
  entity_type,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/fileAttachment/getFileByIdForEntity/${id_entity}/${entity_type}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// Supprimer un fichier joint
export const deleteFileAttachementByID = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/fileAttachment/delete/${id}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

// récupérer un fichier joint à travers son nom pour des actions comme l'affichage, le téléchargement, etc.
export const getFileAttachementByName = async (
  entity_type,
  filename,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/fileAttachment/file/${entity_type}/${filename}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};

export const getFileValidationByEntity = async (entity_type, id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl +
      `/api/fileValidation/getFileValidationByIdForEntity/${id}/${entity_type}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
